import React from 'react';

function Contact() {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2 className="section-title">Contact Us</h2>
        <div className="contact-content-center">
          <div className="contact-info">
            <div className="info-card">
              <h3>Contact Information</h3>
              <p><strong>Phone:</strong> (909) 925-8671</p>
              <p><strong>Email:</strong> morninglight.fs@outlook.com</p>
              <p><strong>Website:</strong> www.mlfuneral.com</p>
            </div>
            <div className="info-card">
              <h3>Visit Us</h3>
              <p>8608 Utica Avenue, Suite 220ML<br/>
              Rancho Cucamonga, California 91730</p>
              <p><strong>Hours:</strong> Mon-Sat 8AM-3PM</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
